import { Card } from "@components/Card";
import { Drilling } from "./Drilling";
import { CounterDeepening } from "./CounterDeepening";
import cs from "./AdditionalProcessing.module.scss";

export const AdditionalPlasticProcessing = ({
  additionalServices,
  onChange,
  onRemove,
}) => {
  return (
    <Card className="AdditionalMetalProcessing">
      <Card.Header className="h4">
        Dodatkowa obróbka tworzyw sztucznych
      </Card.Header>

      <Card.Body className={cs.services}>
        {additionalServices.map((priceList) => {
          switch (priceList.service._id) {
            case 129:
              return (
                <Drilling
                  key={priceList.service._id}
                  priceList={priceList}
                  onChange={(updatedPriceList) => {
                    onChange(priceList.service._id, updatedPriceList);
                  }}
                  onRemove={onRemove}
                />
              );
            case 131:
            case 132:
              return (
                <CounterDeepening
                  key={priceList.service._id}
                  priceList={priceList}
                  onChange={(updatedPriceList) => {
                    onChange(priceList.service._id, updatedPriceList);
                  }}
                  onRemove={onRemove}
                />
              );
            default:
              return null;
          }
        })}
      </Card.Body>
    </Card>
  );
};
